









import { Vue, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';

@Component

export default class ProductYoutubeVideo extends Vue {
    @Prop({ type: String, required: true })
    url!: string;

    @Prop({
        required: true,
        type: String
    }) mode!: string;

    @Prop({
        required: true,
        type: Boolean
    }) startVideo!: boolean;

    @Prop({
        required: true,
        type: Boolean
    }) allowControls!: boolean;

    get videoId() {
        const youtubeRegex = /^.*((youtube\/)|(youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = this.url.match(youtubeRegex);

        return (match && match[8].length >= 11) ? match[8].slice(0, 11) : 'default';
    }

    // Fixes iframe same-origin issues: https://stackoverflow.com/questions/41522652/refused-to-display-url-in-a-frame-because-it-set-x-frame-options-to-sameori/49330250#49330250
    get youtubeUrl() {
        return `https://youtube.com/embed/${this.videoId}?autoplay=${this.startVideo ? 1 : 0}`;
    }

    get videoImage() : string {
        return `https://i.ytimg.com/vi/${this.videoId}/${this.imageResolution}.jpg`;
    }

    get imageResolution() : string {
        return this.mode === 'thumbnail' ? 'mqdefault' : 'maxresdefault';
    }
}
